import React, { createContext, useContext, useState, useEffect } from 'react';
import { DictionaryService } from '../../api/DictionaryService';
import { catchCallback } from '../../api/request';

const DictionaryContext = createContext(null);

function DictionaryProvider({ children }) {
    const [dictionary, setDictionary] = useState({});

    useEffect(() => {
        const request = DictionaryService.get();

        request
            .then((data) => {
                setDictionary(data);
            })
            .catch(
                catchCallback((error) => {
                    console.error('Dictionary has not been loaded', error);
                }),
            );

        return () => {
            request.cancel();
        };
    }, []);

    return <DictionaryContext.Provider value={dictionary}>{children}</DictionaryContext.Provider>;
}

function useDictionary() {
    const context = useContext(DictionaryContext);

    if (context === undefined) {
        throw new Error('useDictionary must be used within a DictionaryProvider');
    }

    return context;
}

export { DictionaryProvider, useDictionary };
